import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

/**
 * Which map and search the app uses (spec 2026-10-22-mapy-google §2), from the server: the Google map with both keys
 * set, else OpenStreetMap as before. `browserKey` only shows the map (the server searches with its own key).
 */
export type GeoConfig = { map: 'google' | 'osm'; browserKey: string | null; mapId: string | null; search: 'google' | 'osm' | 'none'; routes: boolean };

export const GEO_CONFIG_KEY = ['geo-config'] as const;
const OSM: GeoConfig = { map: 'osm', browserKey: null, mapId: null, search: 'none', routes: false };

/** The mode; while it loads `pending`, and anything unexpected counts as OpenStreetMap without Google. */
export function useGeoConfig(): { config: GeoConfig; pending: boolean } {
  const q = useQuery({ queryKey: GEO_CONFIG_KEY, queryFn: () => api<GeoConfig>('/api/geo/config'), staleTime: Infinity, retry: false });
  const data = q.data;
  const valid = !!data && (data.map === 'google' || data.map === 'osm');
  return { config: valid ? { ...OSM, ...data, browserKey: data.map === 'google' ? data.browserKey : null } : OSM, pending: q.isPending };
}
